import firebase from "firebase/compat/app";
// import removeChallengeGroup from "./removeChallengeGroup";

const removeChallenge = async function(competition_id) {
  let db = firebase.firestore();
  if (competition_id) {

    //TODO remove group/users when delete challenge
    // get group list by competition_id
    // const groupSnapshot = await db
    //   .collection("wellness_competition")
    //   .doc(competition_id)
    //   .collection("groups")
    //   .get();

    // await groupSnapshot.forEach((doc) => {
    //   removeChallengeGroup(competition_id, doc.id);
    // });

    //remove challenge
    await db
      .collection("wellness_competition")
      .doc(competition_id)
      .delete();
  }
};

export default removeChallenge;
